import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import { useEffect } from 'react';
import SettingsPersonalInfoForm from '@features/settings-personal-info/containers/SettingsPersonalInfoForm';

const pageValues = {
  title: 'Personal Information',
  description: 'Update your photo and personal details here',
};

function SettingsPersonalInfoPage() {
  usePageTitle('ZlaytAI - Personal Information');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <SettingsPersonalInfoForm />;
}

export default SettingsPersonalInfoPage;
